import React from 'react';

interface CheckIconProps {
  size?: number;
  color?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({
  size = 12,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 10.2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.428591 6.42858L2.76859 9.43711C2.84755 9.53971 2.94873 9.62311 3.06452 9.68105C3.18031 9.73891 3.30772 9.76985 3.43716 9.7714C3.56453 9.77294 3.69062 9.74594 3.80627 9.69263C3.92192 9.63923 4.02422 9.56071 4.10573 9.46283L11.5714 0.428583"
      stroke={color}
      strokeWidth="0.857143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CheckIcon;
